<template>
    <fade-up-animation :element="() => $refs.section">
        <div class="restaurant-locations-section" ref="section">
            <b-container>
                <mobile-gutter>
                    <b-row>
                        <b-col>
                            <restaurant-cta-list :restaurants="restaurants" />
                        </b-col>
                    </b-row>
                </mobile-gutter>
            </b-container>
        </div>
    </fade-up-animation>
</template>

<script>
    import RestaurantCtaList from '../RestaurantCtaList/RestaurantCtaList';

    export default {
        name: 'restaurant-locations-section',

        components: { RestaurantCtaList },

        props: {
            restaurants: {
                type: Array,
                required: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
    .restaurant-locations-section {
        padding-top: 50px;
        margin-bottom: 50px;
        @include media-breakpoint-up(lg) {
            padding-top: 90px;
        }
    }

    .restaurant-cta-list {
        max-width: 1225px;
    }
</style>
